<template>
  <div>
    <div>
      <!-- <b-row>
          <b-col cols="12" class="pr-1">
            <b-form-group>
              <b-form-radio-group
                size="md"
                id="search-options-group"
                v-model="selectedSearchOption"
                :options="searchOptions"
                name="radio-options"
                @change="changeOption"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row> -->
      <b-input-group size="lg" class="text-center">
        <b-row class="w-100 text-left">
          <b-col cols="12" class="pr-1">
            <ProductCoolSelect @selected="selectProduct" :searchWith="selectedSearchOption" :value="selected"
              ref="coolselect" />
          </b-col>

        </b-row>

      </b-input-group>
      <b-row>
        <b-col cols="12" class="p-0" v-if="selectedProduct != null">
          <PickUnitBatch @addProduct="addProductToBill" :data="selectedProduct" ref="PickProductUnitAndBatch" />
        </b-col>
        <b-col v-if="NoStock">
          <b-alert show variant="warning">No stock available</b-alert>
        </b-col>
        <!-- <b-col class="mt-2 p-0" v-if="selectedBarcode != null">
          <b-row>
            <b-col cols="5">
              <div><img height="100" :src="selectedBarcode.image" /></div>
            </b-col>
            <b-col cols="5">
              <div>
                <h5>{{ selectedBarcode.name }}</h5>
              </div>
              <div>
                <h5>{{ selectedBarcode.brand }}</h5>
              </div>
              <div>
                <h5>{{ selectedBarcode.batch.name }}</h5>
              </div>
              <div>
                <h5>{{ selectedBarcode.unit.name }}</h5>
              </div>
              <div>
                <h5>{{ selectedBarcode.selling_price }}</h5>
              </div>
            </b-col>

            <b-col cols="2">
              <b-button @click="addProductToBillWithBarcode(selectedBarcode)">Add</b-button>
            </b-col>
          </b-row>
        </b-col> -->
      </b-row>
    </div>
    <!-- <b-row
        v-if="product.units.length == 0 && !loading"
        class="pl-3 pr-3 text-center"
      >
        <b-col>
          <b-alert show variant="warning">No Units Found</b-alert>
        </b-col>
      </b-row> -->
    <!-- </b-modal> -->
  </div>
</template>

<script>
import { SwipeList, SwipeOut } from 'vue-swipe-actions';
import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import axios from '@/plugins/axios';
// Components
import PickUnitBatch from '@/components/shared/PickProductUnitAndBatchWithoutModal';
import ProductCoolSelect from '@/components/shared/ProductCoolSelect';

// Models
import { ProductModel } from '@/models/ProductModel';
import { BillModel, BillDecorator } from '@/models/BillModel';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'PickProductUnitandBatch',
  methods: {
    createUser() { },
    addProductToBill(data) {
      var product = this.selectedProduct;
      // product.price = data.batch.selling_price;
      product.batch = data.batch;
      product.unit = data.unit;
      if (data.setCurrentMoneyVisible) {
        product.price = data.setCurrentMoney;
      } else {
        product.price = data.batch.selling_price;
      }
      product.minCurrentMoneyVisible = data.setCurrentMoneyVisible;
      // product.unit.batches = [data.batch];
      product.available_stock = data.available_stock;
      this.$store.dispatch(
        'bill/AddProduct',
        new BillDecorator(product).toBill()
      );
      this.showToast('Product added', 'success');
      this.hideModal();
    },
    addProductToBillWithBarcode(data) {
      // var product = data;

      // product.price = data.selling_price;
      // product.batch = data.batch;
      // product.unit = data.unit;
      // product.available_stock = data.available_stock;
      this.$store.dispatch('bill/AddProduct', new BillDecorator(data).toBill());
      this.showToast('Product added', 'success');
      this.hideModal();
    },
    changeOption() {
      this.$refs.coolselect.clearSelect();
      this.selected = {};
      this.selectedProduct = null;
      this.selectedProduct = null;
      this.selectedBatch = null;
      this.selectedBarcode = null;
    },
    getAvailableStock(data) {
      return new Promise((resolve, reject) => {
        this.NoStock = false;
        axios
          .post(
            'pos/shops/' +
            this.shop_info.id +
            '/product/' +
            data.id +
            '/batch/' +
            data.batch_id +
            '/unit/' +
            data.unit_id,
            this.GetSelectedProductUnitsAndQuantity(this.data.id, 0)
          )
          .then((res) => {
            if (res.data?.data?.available_stock > 0) {
              data.available_stock = res.data.data.available_stock;
              data.quantity = 1;
              data.price = data.selling_price;
              data.batch = {};
              data.batch.isBargained = false;
              data.batch.bargained_amount = 0;
              data.batch.selling_price = data.selling_price;
              resolve(data);
            } else {
              this.NoStock = true;
              this.showToast('No Available Stock', 'danger');
            }
          })
          .catch((err) => {
            this.NoStock = true;
            this.showToast('No Available Stock', 'danger');
            reject();
          });
      });
    },
    async selectProduct(payload) {
      this.NoStock = false;
      this.selectedBarcode = await this.getAvailableStock(payload);
      this.addProductToBillWithBarcode(this.selectedBarcode)
      this.$refs.coolselect.clearSelect();
    },
    calculatePercentage(item) {
      let result = (item.bargained_amount / item.selling_price) * 100;
      if (result % 1 == 0) {
        item.bargained_percentage = result;
      } else {
        item.bargained_percentage = result.toFixed(2);
      }
    },
    calculateAmount(item) {
      item.bargained_amount =
        (item.bargained_percentage * item.selling_price) / 100;
    },
    // AddBargainAmount(value, batchIndex) {
    // this.$store.commit("bill/ADD_BARGAIN_AMOUNT", {
    //   value,
    //   batchIndex,
    //   batchIndex: this.selectedbatchIndex,
    // });
    //   this.selectedBatch[batchIndex].bargained_amount = value;
    // },
    focusAmountTextBox(value, batch) {
      // batch.bargained_percentage = 0;
      // batch.bargained_amount = 0;
      if (value) {
        this.$refs.bargainedAmount[0].focus();
      }
    },
    initiate() {
      this.fetchCount = 0;
      this.product = Object.assign({}, ProductModel);
      this.NoStock = false;
      // this.selectedBatch = null;
      this.selectedBarcode = null;
      this.selectedProduct = null;

      this.selectedBatch = null;
      this.selectedBatchIndex = {};
    },
    selectUnit(unit) {
      this.selectedUnit = unit;
    },
    selectBatch(batch, index) {
      this.selectedBatch = batch;
      if (
        batch.bargained_amount == undefined &&
        batch.bargained_percentage == undefined
      ) {
        batch.bargained_amount = 0;
        batch.bargained_percentage = 0;
      }
      this.selectedBatchIndex = index;
      // Available Stock
      axios
        .get(
          'pos/shops/' +
          this.shop_info.id +
          '/product/' +
          this.data.id +
          '/batch/' +
          this.selectedBatch.id +
          '/unit/' +
          this.selectedUnit.id
        )
        .then((res) => {
          if (res.data?.data?.available_stock != 0) {
            this.$emit('addProduct', {
              batch: batch,
              unit: this.selectedUnit,
              available_stock: res.data.data.available_stock,
            });
            this.hideModal();
          } else {
            // this.show
          }
        })
        .catch((err) => { });
    },
    fetchProduct() {
      this.loading = true;
      var productId = this.data.id;
      this.$store
        .dispatch('product/fetchUnitAndBatch', {
          productId: this.data.id,
          selectedUnits: this.GetSelectedProductUnitsAndQuantity(this.data.id),
        })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.product = res.data.data;
          } else if (res.status == 204) {
            this.product = Object.assign({}, ProductModel);
            this.product.name = this.data.name;
            this.reloadContent();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.suspend_lists = [];
        });
    },
    reloadContent() {
      if (this.fetchCount < 2) {
        this.fetchProduct();
        this.fetchCount++;
      }
    },
    showModal() {
      this.loading = true;
      this.initiate();
      setTimeout(() => {
        this.fetchProduct();
      }, 200);
      this.$refs['ModalSearchProduct'].show();
    },
    hideModal() {
      this.$refs['ModalSearchProduct'].hide();
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: `Message`,
        variant: variant,
        solid: true,
      });
    },
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedUnit: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // selectedBatch: {
    //   type: Object,
    //   default: function () {
    //       return []
    //   }
    // },
  },
  data: () => ({
    // dialog: false
    // tab: 0,
    selected: {},
    loading: null,
    product: Object.assign({}, ProductModel),
    // selectedUnit: [],
    // selectedBatch: [],
    selectedBatchIndex: {},
    fetchCount: 0,
    mockSwipeList: [
      {
        id: 0,
        title: 'Some title',
        description: 'some description',
      },
      {
        id: 1,
        title: 'Some title',
        description: 'some description',
      },
      {
        id: 2,
        title: 'Some title',
        description: 'some description',
      },
    ],
    selectedSearchOption: 'barcode',
    searchOptions: [
      { text: 'Barcode', value: 'barcode' },
      { text: 'Batch', value: 'batch' },
      { text: 'Product Name', value: 'product_name' },
    ],

    // emitted data
    selectedProduct: null,
    selectedBatch: null,
    selectedBarcode: null,

    NoStock: false,
  }),
  computed: {
    buttonText: function () {
      switch (this.selectedSearchOption) {
        case 'barcode':
          return 'Add';
          break;
        case 'batch':
          return 'Next';
          break;
        case 'product_name':
          return 'Next';
          break;
        default:
          return 'Add';
      }
    },
    ...mapState('shops', ['shop_info']),
    ...mapGetters('bill', ['GetSelectedProductUnitsAndQuantity']),
  },
  components: {
    SwipeOut,
    SwipeList,
    ProductCoolSelect,
    PickUnitBatch,
  },
  mounted: function () {
    // this.initialize();
  },
};
</script>

<style>
.unit,
.batch {
  font-family: 'Poppins';
  font-weight: 600;
  padding: 20px 11px;
  border: 1px solid #634a00;
  border-radius: 11px;
  /* width: 200px; */
  text-align: center;
  box-shadow: 1px 1px 0px 0px black;
}

.selected {
  background-color: #ffc107;
  color: #162947;
  box-shadow: unset;
  border: 1px solid white;
}

.unit:hover,
.unit:active,
.batch:hover {
  background-color: #ffd557;
  border: 1px solid #ffd557;
  color: #162947;
}
</style>
